<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Create Activity</p>
            </header>

            <section class="modal-card-body">
                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="copy.title" placeholder="Task Title" />
                </o-field>

                <o-field label="Description" :type="fieldType('description')">
                    <quill-editor v-model:content="copy.description" :content-type="'html'" :error="getError('description')" />
                </o-field>

                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <multiselect
                                :options="allUsers"
                                v-model="subscribers" :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="true"
                                :preserve-search="true"
                                placeholder="Who will be notified"
                                track-by="id"
                                label="full_name"
                                value-prop="id"
                            />
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <multiselect
                                :options="contacts"
                                v-model="subscribedContacts"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="true"
                                :preserve-search="true"
                                placeholder="Subscribed Contacts to notify"
                                track-by="id"
                                label="full_name"
                                value-prop="id"
                            />
                        </div>
                    </div>
                </div>

                <o-field label="Status" :type="fieldType('status')" :message="getError('status')">
                    <o-select placeholder="Select a status" v-model="copy.status" expanded>
                        <option
                                v-for="status in taskStatuses"
                                :value="status.id"
                                :key="status.id"
                        >
                            {{ status.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Location" :type="fieldType('location')" :message="getError('location')">
                    <o-select placeholder="Select a Task Location" v-model="copy.location" expanded>
                        <option :value="null">Not Specified</option>
                        <option
                                v-for="(location, key) in taskLocations"
                                :key="key"
                                :value="location.id"
                        >
                            {{ location.name }}
                        </option>
                    </o-select>
                </o-field>

                <div class="field">
                    <o-checkbox v-model="copy.is_package_log">Activity is a package log</o-checkbox>
                </div>

                <div class="columns">
                    <div class="column">
                        <o-field label="Assigned To" :type="fieldType('assignee_id')" :message="getError('assignee_id')">
                            <autocomplete-select type="user" v-model="copy.assignee_id" />
                        </o-field>
                    </div>
                    <div class="column">
                        <o-field label="Contact" :type="fieldType('contact_id')" :message="getError('contact_id')">
                            <o-select placeholder="Select a Task Contact" v-model="copy.contact_id" expanded>
                                <option :value="null">Not Specified</option>
                                <option
                                        v-for="(contact, key) in projectContactsByProjectId(copy.project_id)"
                                        :key="key"
                                        :value="contact.id"
                                >
                                    {{ contactNameById(contact.id) }}
                                </option>
                            </o-select>
                        </o-field>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <o-field label="Date Created">
                            <datepicker :error="getError('date_created')" v-model="copy.date_created" />
                        </o-field>

                        <o-field label="Date Completed">
                            <datepicker :error="getError('date_completed')" v-model="copy.date_completed" />
                        </o-field>

                    </div>
                    <div class="column">
                        <o-field label="Date Requested">
                            <datepicker :error="getError('date_requested')" v-model="copy.date_requested" />
                        </o-field>

                        <o-field label="Date Received">
                            <datepicker :error="getError('date_received')" v-model="copy.date_received" />
                        </o-field>

                    </div>
                    <div class="column">
                        <o-field label="Date Sent">
                            <datepicker :error="getError('date_sent')" v-model="copy.date_sent" />
                        </o-field>

                        <o-field label="Due Date">
                            <datepicker :error="getError('due_date')" v-model="copy.due_date" />
                        </o-field>
                    </div>
                </div>

                <div class="field">
                    <uploadcare v-model="copy.files" format="object" :multiple="true" />
                </div>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import Datepicker from './../../../../components/Datepicker'
    import Uploadcare from './../../../../components/Uploadcare'
    import HandlesForm from './../../../../mixins/HandlesForm'
    import {mapActions, mapGetters} from 'vuex'
    import Multiselect from '@vueform/multiselect'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
        components: {
          QuillEditor,
            Multiselect,
            Datepicker,
            Uploadcare
        },

        mixins: [HandlesForm],

        data () {
            return {
                subscribedContacts: [],
                subscribers: null,

                copy: {
                    date_created: moment().format('YYYY-MM-DD'),
                    is_package_log: false,
                    application_type: '',
                    date_completed: null,
                    application_id: '',
                    is_external: false,
                    assignee_id: null,
                    contact_id: null,
                    creator_id: null,
                    project_id: null,
                    category_id: '',
                    description: '',
                    due_date: null,
                    location: null,
                    files: [],
                    status: 2,
                    title: ''
                },
                taskLocations: [],
            }
        },

        computed: {
            ...mapGetters([
                'projectContactsByProjectId',
                'applicationName',
                'contactNameById',
                'taskStatuses',
                'allUsers',
                'contacts'
            ])
        },

        methods: {
            ...mapActions(['createTask', 'fetchTaskBasedCompanies']),

            handleSubmit() {
                let submit = this.wrapSubmit(this.createTask)

                submit(this.copy)
                    .then(res => {
                        this.successMessage('Task has been successfull updated')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            }
        },
        mounted () {
            this.fetchTaskBasedCompanies().then(res => {
                this.taskLocations = res.data.data
            })
        },
    }
</script>
